export class Challenger {
    constructor(name, userId, chaptersRead, completedDate) {
        this.name = name;
        this.userId = userId;
        this.chaptersRead = chaptersRead;
        this.completedDate = completedDate;
    }

    static from_json(json) {
        return new Challenger(json.name, json.userId, json.chaptersRead, json.completedDate);
    }

    static from_user(user) {
        return new Challenger(user.get_name(), user.get_id(), 0, null);
    }

    get_name() {
        return this.name;
    }

    get_chapters_read() {
        return this.chaptersRead;
    }

    get_completed_date() {
        return this.completedDate;
    }

    get_user_id() {
        return this.userId;
    }
}